import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3 className="footer-heading">Daniel Airline</h3>
          <p className="footer-text">Your trusted partner for comfortable air travel.</p>
        </div>

        <div className="footer-section">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-links">
            <li>
              <Link className="footer-link" to="/flights">
                Book Flights
              </Link>
            </li>
            <li>
              <Link className="footer-link" to="/contact">
                Contact Us
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3 className="footer-heading">Legal</h3>
          <ul className="footer-links">
            <li>
              <Link className="footer-link" to="/terms">
                Terms of Service
              </Link>
            </li>
            <li>
              <Link className="footer-link" to="/privacy">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2025 Daniel Airline. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
